import { ShowHideColumnsMenu } from '@dealstack/frontend/shared/components/Table/MantineTable/ShowHideColumnsButton/ShowHideColumnsMenu';
import { TableToolbarButtonProps } from '@dealstack/frontend/shared/components/Table/MantineTable/table-utils';
import { TooltipButton } from '@dealstack/frontend/shared/components/Table/MantineTable/TooltipButton/TooltipButton';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { Z_INDEX } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';
import { RecordAny } from '@dealstack/shared/lib/common/common';
import { Menu } from '@mantine/core';
import { Table } from '@tanstack/react-table';
import { useState } from 'react';

export const ShowHideColumnsButton = <TData extends RecordAny>({
	table,
	customSettingsRenderer,
	...rest
}: TableToolbarButtonProps<TData> & {
	customSettingsRenderer?: (table: Table<TData>) => JSX.Element;
}) => {
	const tCommonUi = useTranslationCommonUi();

	const [opened, setOpen] = useState(false);

	return (
		<Menu
			closeOnItemClick={false}
			opened={opened}
			onClose={() => setOpen(false)}
			onOpen={() => setOpen(true)}
			position="bottom-end"
			withinPortal
			zIndex={Z_INDEX.MENU}
		>
			<Menu.Target>
				<TooltipButton
					style={{
						width: '7.125rem',
					}}
					tooltipLabel={
						rest?.title ?? tCommonUi('mantine_table.tooltip.show_hide_columns')
					}
					active={opened}
					{...rest}
					text={tCommonUi('mantine_table.top_toolbar.settings')}
				/>
			</Menu.Target>

			<ShowHideColumnsMenu
				table={table}
				customRenderer={customSettingsRenderer}
				closeMenu={() => setOpen(false)}
			/>
		</Menu>
	);
};
